import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  name: {
    marginBottom: theme.spacing(2),
  },
  companyLogo: {
    height: 23,
    objectFit: 'contain',
  },
  divider: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.colors.divider}`,
  },
  icon: {
    fill: theme.palette.colors.teal,
  },
  aboutMeText: {
    margin: [16, 0, 32, 0],
  },
  contact: {
    color: theme.palette.colors.black,
  },
  textLink: {
    '& p': {
      fontSize: '12px',
      margin: 0,
    },
    '& a': {
      fontWeight: 400,
      color: theme.palette.colors.black,
      '&:hover': {
        color: theme.palette.colors.black,
      },
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerInfoBar/useStyles.js